<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Tipo Contato:"
    id="selectTipoContato"
    placeholder="Selecione o Tipo de Contato"
    :multiple="false"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxSelectReduced>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectTipoContato',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listOptions: [
        { value: 'CELULAR', text: 'CELULAR' },
        {
          value: 'COMERCIAL',
          text: 'COMERCIAL'
        },
        {
          value: 'RESIDENCIAL',
          text: 'RESIDENCIAL'
        }
      ],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoContato.vue